import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from "@/shared/hooks";
import { previewFeaturesMapIcon } from "@/components/Sections/Features/constants";
import { useSections } from "@/contexts/classified";
import { CheckCircleIcon } from "@gemini/icons";
export const useFeatures = () => {
    var _a, _b, _c, _d, _e;
    const features = (_a = useSections()) === null || _a === void 0 ? void 0 : _a.features;
    const { t } = useI18n();
    if (!features)
        return null;
    const { details, preview } = features;
    const previewWithIcon = preview === null || preview === void 0 ? void 0 : preview.map((feature) => {
        var _a;
        return (Object.assign(Object.assign({}, feature), { Icon: (_a = previewFeaturesMapIcon[feature.icon]) !== null && _a !== void 0 ? _a : (_jsx(CheckCircleIcon, {})) }));
    });
    const categoriesWithIcon = (_b = details === null || details === void 0 ? void 0 : details.categories) === null || _b === void 0 ? void 0 : _b.map((category) => (Object.assign(Object.assign({}, category), { elements: category.elements.map((feature) => {
            var _a;
            return (Object.assign(Object.assign({}, feature), { Icon: (_a = previewFeaturesMapIcon[feature.icon]) !== null && _a !== void 0 ? _a : (_jsx(CheckCircleIcon, {})) }));
        }) })));
    const previewCount = (_c = preview === null || preview === void 0 ? void 0 : preview.length) !== null && _c !== void 0 ? _c : 0;
    const detailsCount = (_e = (_d = details === null || details === void 0 ? void 0 : details.categories) === null || _d === void 0 ? void 0 : _d.reduce((acc, item) => acc + item.elements.length, 0)) !== null && _e !== void 0 ? _e : 0;
    const buttonLabel = detailsCount > 8
        ? t("features.cta.with_count", {
            replace: {
                count: detailsCount,
            },
        })
        : t("features.cta.default");
    const hideSection = !(details === null || details === void 0 ? void 0 : details.additionalText) && previewCount === 0 && detailsCount === 0;
    return {
        additionalText: details === null || details === void 0 ? void 0 : details.additionalText,
        categories: categoriesWithIcon,
        preview: previewWithIcon,
        previewCount,
        detailsCount,
        buttonLabel,
        hideSection,
    };
};
